export default "__VITE_ASSET__f2afcbb2__$_?inline__"